import {appointmentsApi,qNegozioApi} from './api';
export const italianDay = value => new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Rome',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date(value));
export function agendaWindow(now=new Date()) {
 const from=italianDay(now),end=new Date(`${from}T12:00:00Z`);end.setUTCDate(end.getUTCDate()+7);
 return {from,to:italianDay(end)};
}
const labels={Pending:'Da confermare',Confirmed:'Confermato',InProgress:'In corso',Completed:'Completato',Cancelled:'Annullato',NoShow:'Non presentato'};
export async function loadStudioAppointments(now=new Date()) {
 const range=agendaWindow(now),status=await qNegozioApi.status();
 if(status.configured){
  const result=await qNegozioApi.agenda(range.from,range.to);
  return result.items.map(item=>({...item,id:`q-${item.externalId}`,displayName:item.customerName||'Appuntamento',type:item.service,status:labels[item.status]||item.status})).sort((a,b)=>new Date(a.startsAt)-new Date(b.startsAt));
 }
 // Fetch a wider UTC window, then filter by the studio's Italian calendar days.
 const start=new Date(`${range.from}T00:00:00Z`);start.setUTCDate(start.getUTCDate()-1);
 const items=await appointmentsApi.getAll(start.toISOString(),`${range.to}T00:00:00Z`);
 return (items||[]).filter(item=>italianDay(item.startsAt)>=range.from&&italianDay(item.startsAt)<range.to).sort((a,b)=>new Date(a.startsAt)-new Date(b.startsAt));
}
